/* -------------------------------------------------------------------------
   CARBONIZE REVIEWS
   Sorting, star filtering, paging, lightbox and the write-a-review panel.
   No dependencies. Multiple instances per page are supported.
------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (customElements.get('cz-reviews')) return;

  var LIGHTBOX_ID = 'cz-lightbox';

  function getLightbox() {
    var el = document.getElementById(LIGHTBOX_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = LIGHTBOX_ID;
    el.className = 'cz-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.hidden = true;
    el.innerHTML =
      '<button type="button" class="cz-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="cz-lightbox__nav cz-lightbox__nav--prev" aria-label="Previous">&#8249;</button>' +
      '<button type="button" class="cz-lightbox__nav cz-lightbox__nav--next" aria-label="Next">&#8250;</button>' +
      '<div class="cz-lightbox__panel">' +
      '<div class="cz-lightbox__media"><img alt=""></div>' +
      '<div class="cz-lightbox__body">' +
      '<p class="cz-lightbox__author"></p>' +
      '<p class="cz-lightbox__date"></p>' +
      '<div class="cz-lightbox__stars"></div>' +
      '<p class="cz-lightbox__text"></p>' +
      '</div></div>';

    document.body.appendChild(el);

    el.addEventListener('click', function (event) {
      if (event.target === el || event.target.closest('.cz-lightbox__close')) close();
      if (event.target.closest('.cz-lightbox__nav--prev')) step(-1);
      if (event.target.closest('.cz-lightbox__nav--next')) step(1);
    });

    document.addEventListener('keydown', function (event) {
      if (el.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });

    function close() {
      el.hidden = true;
      el.classList.remove('is-open');
      document.documentElement.style.removeProperty('overflow');
      if (el.__opener && el.__opener.isConnected) el.__opener.focus();
    }

    function step(delta) {
      var list = el.__list || [];
      if (list.length < 2) return;
      var next = (el.__index + delta + list.length) % list.length;
      el.__render(next);
    }

    el.__render = function (index) {
      var list = el.__list || [];
      var card = list[index];
      if (!card) return;

      el.__index = index;

      var img = card.querySelector('.cz-review__img');
      var opener = card.querySelector('[data-cz-open]');
      var target = el.querySelector('.cz-lightbox__media img');
      var full = opener ? opener.dataset.czFull : '';
      target.src = full || (img ? (img.currentSrc || img.src) : '');
      target.alt = img ? img.alt : '';

      el.querySelector('.cz-lightbox__author').textContent = text(card, '.cz-review__author');
      el.querySelector('.cz-lightbox__date').textContent = text(card, '.cz-review__date');
      el.querySelector('.cz-lightbox__text').textContent = text(card, '.cz-review__text');

      var stars = card.querySelector('.cz-stars');
      el.querySelector('.cz-lightbox__stars').innerHTML = stars ? stars.outerHTML : '';

      var nav = el.querySelectorAll('.cz-lightbox__nav');
      for (var i = 0; i < nav.length; i++) nav[i].hidden = list.length < 2;
    };

    el.__open = function (list, index, opener) {
      el.__list = list;
      el.__opener = opener || null;
      el.hidden = false;
      el.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      el.__render(index);
      el.querySelector('.cz-lightbox__close').focus();
    };

    function text(card, selector) {
      var node = card.querySelector(selector);
      return node ? node.textContent.trim() : '';
    }

    return el;
  }

  var CzReviews = function () {
    return Reflect.construct(HTMLElement, [], CzReviews);
  };

  CzReviews.prototype = Object.create(HTMLElement.prototype);
  CzReviews.prototype.constructor = CzReviews;
  Object.setPrototypeOf(CzReviews, HTMLElement);

  CzReviews.prototype.connectedCallback = function () {
    if (this.__ready) return;
    this.__ready = true;

    // A product with no reviews still renders the write-a-review button, so bind
    // even when there is no grid; apply() simply does nothing in that case.
    this.grid = this.querySelector('[data-cz-grid]');

    this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-cz-card]'));
    this.moreButton = this.querySelector('[data-cz-more]');
    this.sortControl = this.querySelector('[data-cz-sort]');
    this.emptyNote = this.querySelector('[data-cz-empty]');

    this.step = parseInt(this.dataset.step || '6', 10);
    this.initial = parseInt(this.dataset.initial || '9', 10);
    this.shown = this.initial;
    this.starFilter = 0;
    this.photosOnly = false;

    this.bind();
    this.apply();
  };

  CzReviews.prototype.bind = function () {
    var self = this;

    if (this.sortControl) {
      this.sortControl.addEventListener('change', function () {
        self.shown = self.initial;
        self.apply();
      });
    }

    this.addEventListener('click', function (event) {
      var photoToggle = event.target.closest('[data-cz-photos]');
      if (photoToggle) {
        self.photosOnly = !self.photosOnly;
        photoToggle.setAttribute('aria-pressed', String(self.photosOnly));
        self.shown = self.initial;
        self.apply();
        return;
      }

      var starButton = event.target.closest('[data-cz-star]');
      if (starButton) {
        var value = parseInt(starButton.dataset.czStar, 10);
        self.starFilter = self.starFilter === value ? 0 : value;
        var rows = self.querySelectorAll('[data-cz-star]');
        for (var i = 0; i < rows.length; i++) {
          rows[i].setAttribute('aria-pressed', String(parseInt(rows[i].dataset.czStar, 10) === self.starFilter));
        }
        self.shown = self.initial;
        self.apply();
        return;
      }

      if (event.target.closest('[data-cz-more]')) {
        self.shown += self.step;
        self.apply();
        return;
      }

      if (event.target.closest('[data-cz-reset]')) {
        self.starFilter = 0;
        self.photosOnly = false;
        self.shown = self.initial;
        var pressed = self.querySelectorAll('[aria-pressed="true"]');
        for (var j = 0; j < pressed.length; j++) pressed[j].setAttribute('aria-pressed', 'false');
        self.apply();
        return;
      }

      var writeToggle = event.target.closest('[data-cz-write-toggle]');
      if (writeToggle) {
        var form = self.querySelector('[data-cz-form]');
        if (form) {
          form.hidden = !form.hidden;
          writeToggle.setAttribute('aria-expanded', String(!form.hidden));
          if (!form.hidden) {
            form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            var firstField = form.querySelector('input, textarea');
            if (firstField) firstField.focus();
          }
        }
        return;
      }

      var opener = event.target.closest('[data-cz-open]');
      if (opener && this.dataset.lightbox !== 'false') {
        var card = opener.closest('[data-cz-card]');
        var withPhotos = self.visible().filter(function (item) { return item.dataset.photo === '1'; });
        var index = withPhotos.indexOf(card);
        if (index > -1) getLightbox().__open(withPhotos, index, opener);
      }
    });
  };

  CzReviews.prototype.visible = function () {
    return this.cards.filter(function (card) { return !card.hidden; });
  };

  CzReviews.prototype.apply = function () {
    if (!this.grid) return;
    var self = this;
    var mode = this.sortControl ? this.sortControl.value : 'recent';

    var matched = this.cards.filter(function (card) {
      if (self.photosOnly && card.dataset.photo !== '1') return false;
      if (self.starFilter && parseInt(card.dataset.rating, 10) !== self.starFilter) return false;
      return true;
    });

    matched.sort(function (a, b) {
      var an = Number(a.dataset.ts || 0);
      var bn = Number(b.dataset.ts || 0);
      var ar = Number(a.dataset.rating || 0);
      var br = Number(b.dataset.rating || 0);
      var ai = Number(a.dataset.index || 0);
      var bi = Number(b.dataset.index || 0);

      switch (mode) {
        case 'oldest': return an - bn || ai - bi;
        case 'highest': return br - ar || bn - an;
        case 'lowest': return ar - br || bn - an;
        case 'photos':
          return (Number(b.dataset.photo) - Number(a.dataset.photo)) || bn - an;
        case 'featured': return ai - bi;
        default: return bn - an || ai - bi;
      }
    });

    this.cards.forEach(function (card) { card.hidden = true; });
    matched.slice(0, this.shown).forEach(function (card) { card.hidden = false; });

    // CSS multi-column ignores flex/grid `order`, so reorder in the DOM.
    matched.forEach(function (card) { self.grid.appendChild(card); });

    if (this.moreButton) {
      var remaining = matched.length - this.shown;
      this.moreButton.hidden = remaining <= 0;
      var label = this.moreButton.querySelector('[data-cz-more-label]') || this.moreButton;
      if (remaining > 0 && this.moreButton.dataset.labelTemplate) {
        label.textContent = this.moreButton.dataset.labelTemplate.replace('[count]', remaining);
      }
    }

    if (this.emptyNote) this.emptyNote.hidden = matched.length > 0;
  };

  customElements.define('cz-reviews', CzReviews);

  /* --------------------------------------------------------- snippets carousel */
  if (!customElements.get('cz-snippets')) {
    var CzSnippets = function () {
      return Reflect.construct(HTMLElement, [], CzSnippets);
    };

    CzSnippets.prototype = Object.create(HTMLElement.prototype);
    CzSnippets.prototype.constructor = CzSnippets;
    Object.setPrototypeOf(CzSnippets, HTMLElement);

    CzSnippets.prototype.connectedCallback = function () {
      var track = this.querySelector('[data-cz-track]');
      if (!track) return;

      this.addEventListener('click', function (event) {
        var button = event.target.closest('[data-cz-scroll]');
        if (!button) return;
        var direction = button.dataset.czScroll === 'prev' ? -1 : 1;
        track.scrollBy({ left: direction * Math.round(track.clientWidth * 0.8), behavior: 'smooth' });
      });
    };

    customElements.define('cz-snippets', CzSnippets);
  }

  /* Shopify reloads the page after a contact-form post, so reveal the panel again
     and scroll to the confirmation. */
  function revealPostedForm() {
    var success = document.querySelector('[data-cz-form-success]');
    if (!success) return;

    var wrap = success.closest('[data-cz-form]');
    if (wrap) {
      wrap.hidden = false;
      var toggle = document.querySelector('[data-cz-write-toggle][aria-controls="' + (success.closest('form') || {}).id + '"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealPostedForm);
  } else {
    revealPostedForm();
  }
})();
